import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'on-accountant-settings-page',
    templateUrl: './accountant-settings-page.component.html',
    styleUrls: ['./accountant-settings-page.component.scss'],
})
export class AccountantSettingsPageComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
